module.exports = "<p>\r\n  comments works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/myreports/comments/comments.component.html
// module id = ./src/app/myreports/comments/comments.component.html
// module chunks = main